import { LoadingOutlined } from "@ant-design/icons";
import { Form, Select, Slider } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { SOFT_SKILLS } from "../../utils/constant";
import { PencilIcon } from "../../utils/icons";
import GradientButton from "../Button/GradientButton";
import MyFileUpload from "../Interactions/MyFileUpload";
import MyInput from "../Interactions/MyInput";
import MySelectDropdown from "../Interactions/MySelectDropdown";
import MySlide from "../Interactions/MySlide";

const PersonalityAttributesModal = ({
  modal,
  close,
  isEdit = false,
  data,
  handleSave,
  loading,
}) => {
  const [form] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);
  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );
  const [key, setKey] = useState(Date.now());

  const handleClose = () => {
    form.resetFields();
    setKey(Date.now());
    setIsOpen(false);
    close();
  };

  useEffect(() => {
    setIsOpen(modal); // Open modal when `modal` prop changes
  }, [modal]);

  const marks = {
    0: "0",
    25: "novice",
    50: "average",
    75: "expert",
    100: "superior",
  };

  if (!modal) return <></>;
  if (modal === "SoftSkills") {
    return (
      <Modal isOpen={isOpen} key={key} close={loading ? () => {} : handleClose}>
        <Form
          labelCol={24}
          onFinish={handleSave}
          layout="vertical"
          form={form}
          // initialValues={ isEdit ? { ...data }: {} }
          className="w-full mt-8 flex flex-wrap justify-between items-center gap-x-8 gap-y-5"
        >
          <Form.Item
            className="w-full mb-0"
            name="Name"
            rules={[
              {
                required: true,
                message: "Please select type of your skill",
              },
            ]}
          >
            <MySelectDropdown
              name="Name"
              placeholder="Select Skills"
              options={SOFT_SKILLS?.map(({ Name }) => ({
                label: Name,
                value: Name,
              }))}
            />
          </Form.Item>
          <Form.Item
            className="w-full mb-0"
            name="Description"
            rules={[
              {
                required: true,
                message:
                  "Minimum length of description should be at least 10 characters",
                min: 10,
              },
            ]}
          >
            <MyInput
              name="Description"
              icon={<PencilIcon />}
              placeholder="Description"
            />
          </Form.Item>
          <Form.Item
            className="w-full mb-0"
            name="Slide"
            label="Select the level of Soft Skills"
            rules={[
              {
                required: true,
                message: "Selection is required",
              },
            ]}
          >
            {/* <MySlide
              min={1}
              max={10}
              // value={typeof inputValue === "number" ? inputValue : 0}
            /> */}
            {/* <Slider min={1} max={10} /> */}
            <MySlide
              tooltip={{
                formatter: null,
              }}
              marks={marks}
              step={null}
            />
          </Form.Item>
          <Form.Item
            className="w-full mb-0"
            name="File"
            rules={[
              {
                required: true,
                message: "Attachment is required to",
              },
            ]}
          >
            <MyFileUpload
              name="File"
              type="noGradient"
              action=""
              accept=".pdf, .doc, .docx, image/png, image/jpeg, image/jpg,"
              maxCount="1"
              placeholder="Upload Supporting Evidence"
            />
          </Form.Item>
          <div className="w-full flex justify-center gap-3">
            <GradientButton
              disabled={loading}
              type="submit"
              onClick={form.resetFields()}
            >
              <span>Save</span>
              {loading && <LoadingOutlined />}
            </GradientButton>
            <button
              disabled={loading}
              type="button"
              onClick={handleClose}
              className="bg-gray-500 hover:bg-gray-600 text-pureWhite rounded-full py-2 px-4"
            >
              Cancel
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
  if (modal === "SpecialTalent") {
    return (
      <Modal isOpen={isOpen} key={key} close={loading ? () => {} : close}>
        <Form
          layout="vertical"
          labelCol={1}
          onFinish={handleSave}
          form={form}
          initialValues={isEdit ? { ...data } : {}}
          className="w-full mt-8 flex flex-wrap justify-between items-center gap-x-8 gap-y-5"
        >
          <Form.Item className="w-full mb-0" name="Name">
            <MyInput
              name="Name"
              icon={<PencilIcon />}
              placeholder="Enter any Special Talent you have"
            />
          </Form.Item>
          <Form.Item className="w-full mb-0" name="Description">
            <MyInput
              name="Description"
              icon={<PencilIcon />}
              placeholder="Description"
            />
          </Form.Item>
          <Form.Item
            className="w-full mb-0"
            name="Slide"
            label="Select the level of Special Talent"
          >
            {/* <MySlide
              min={1}
              max={10}
              // value={typeof inputValue === "number" ? inputValue : 0}
            /> */}
            {/* <Slider min={1} max={10} /> */}
            <MySlide
              tooltip={{
                formatter: null,
              }}
              marks={marks}
              step={null}
            />
          </Form.Item>
          <Form.Item className="w-full mb-0" name="File">
            <MyFileUpload
              name="File"
              type="noGradient"
              action=""
              accept=".pdf, .doc, .docx, image/png, image/jpeg, image/jpg,"
              maxCount="1"
              placeholder="Upload Supporting Evidence"
            />
          </Form.Item>
          <div className="w-full flex justify-center gap-3">
            <GradientButton
              disabled={loading}
              type="submit"
              onClick={form.resetFields()}
            >
              <span>Save</span>
              {loading && <LoadingOutlined />}
            </GradientButton>
            <button
              disabled={loading}
              type="button"
              onClick={close}
              className="bg-gray-500 hover:bg-gray-600 text-pureWhite rounded-full py-2 px-4"
            >
              Cancel
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
  if (modal === "AddWebsite") {
    return (
      <Modal isOpen={isOpen} key={key} close={loading ? () => {} : close}>
        <Form
          labelCol={1}
          onFinish={handleSave}
          layout="vertical"
          form={form}
          initialValues={isEdit ? { ...data } : {}}
          className="w-full mt-8 flex flex-wrap justify-between items-center gap-x-8 gap-y-5"
        >
          <Form.Item className="w-full mb-0" name="SpecifyWebsiteURL">
            <MyInput
              name="SpecifyWebsiteURL"
              icon={<PencilIcon />}
              placeholder="Add Websites"
            />
          </Form.Item>
          <Form.Item className="w-full mb-0" name="specifyTypeOfWebsite">
            <MyInput
              name="specifyTypeOfWebsite"
              icon={<PencilIcon />}
              placeholder="github, personal website, company website, blog, social media, etc."
            />
          </Form.Item>
          <div className="w-full flex justify-center gap-3">
            <GradientButton
              disabled={loading}
              type="submit"
              onClick={form.resetFields()}
            >
              <span>Save</span>
              {loading && <LoadingOutlined />}
            </GradientButton>
            <button
              disabled={loading}
              type="button"
              onClick={close}
              className="bg-gray-500 hover:bg-gray-600 text-pureWhite rounded-full py-2 px-4"
            >
              Cancel
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
  if (modal === "AddLanguages") {
    return (
      <Modal isOpen={isOpen} key={key} close={loading ? () => {} : close}>
        <Form
          labelCol={1}
          onFinish={handleSave}
          layout="vertical"
          form={form}
          initialValues={isEdit ? { ...data } : {}}
          className="w-full mt-8 flex flex-wrap justify-between items-center gap-x-8 gap-y-5"
        >
          <Form.Item className="w-full mb-0" name="SpecifyLanguage">
            <MyInput
              name="SpecifyLanguage"
              icon={<PencilIcon />}
              placeholder="Specify Language"
            />
          </Form.Item>
          <Form.Item className="w-full mb-0" name="LanguageProficiency">
            <Select
              // mode="tags"
              size="large"
              // value={value}
            >
              <Select.Option value="Native or Bilingual Proficiency">
                Native or Bilingual Proficiency
              </Select.Option>
              <Select.Option value="Full Professional Proficiency">
                Full Professional Proficiency
              </Select.Option>
              <Select.Option value="Professional working Proficiency">
                Professional working Proficiency
              </Select.Option>
              <Select.Option value="Limited working Proficiency">
                Limited working Proficiency
              </Select.Option>
              <Select.Option value="Elementary Proficiency">
                Elementary Proficiency
              </Select.Option>
            </Select>
          </Form.Item>
          <div className="w-full flex justify-center gap-3">
            <GradientButton
              disabled={loading}
              type="submit"
              onClick={form.resetFields()}
            >
              <span>Save</span>
              {loading && <LoadingOutlined />}
            </GradientButton>
            <button
              disabled={loading}
              type="button"
              onClick={close}
              className="bg-gray-500 hover:bg-gray-600 text-pureWhite rounded-full py-2 px-4"
            >
              Cancel
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
  if (modal === "ExtraCurricularActivities") {
    return (
      <Modal isOpen={isOpen} key={key} close={loading ? () => {} : close}>
        <Form
          labelCol={1}
          onFinish={handleSave}
          layout="vertical"
          form={form}
          initialValues={isEdit ? { ...data } : {}}
          className="w-full mt-8 flex flex-wrap justify-between items-center gap-x-8 gap-y-5"
        >
          <Form.Item className="w-full mb-0" name="Name">
            <MyInput
              name="Name"
              icon={<PencilIcon />}
              placeholder="Enter Extra Curricular Activity"
            />
          </Form.Item>
          <Form.Item className="w-full mb-0" name="Description">
            <MyInput
              name="Description"
              icon={<PencilIcon />}
              placeholder="Description"
            />
          </Form.Item>
          <Form.Item
            className="w-full mb-0"
            name="Slide"
            label="Select the level of ExtraCurricular Activities"
          >
            {/* <MySlide
              min={1}
              max={10}
              // value={typeof inputValue === "number" ? inputValue : 0}
            /> */}
            {/* <Slider min={1} max={10} /> */}
            <MySlide
              tooltip={{
                formatter: null,
              }}
              marks={marks}
              step={null}
            />
          </Form.Item>
          <Form.Item className="w-full mb-0" name="File">
            <MyFileUpload
              name="File"
              type="noGradient"
              action=""
              accept=".pdf, .doc, .docx, image/png, image/jpeg, image/jpg,"
              maxCount="1"
              placeholder="Upload Supporting Evidence"
            />
          </Form.Item>
          <div className="w-full flex justify-center gap-3">
            <GradientButton
              disabled={loading}
              type="submit"
              onClick={form.resetFields()}
            >
              <span>Save</span>
              {loading && <LoadingOutlined />}
            </GradientButton>
            <button
              disabled={loading}
              type="button"
              onClick={close}
              className="bg-gray-500 hover:bg-gray-600 text-pureWhite rounded-full py-2 px-4"
            >
              Cancel
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
  if (modal === "PsychologicalChallenges") {
    return (
      <Modal isOpen={isOpen} key={key} close={loading ? () => {} : close}>
        <Form
          labelCol={1}
          onFinish={handleSave}
          layout="vertical"
          form={form}
          initialValues={isEdit ? { ...data } : {}}
          className="w-full mt-8 flex flex-wrap justify-between items-center gap-x-8 gap-y-5"
        >
          <Form.Item className="w-full mb-0" name="Name">
            <MyInput
              name="Name"
              icon={<PencilIcon />}
              placeholder="Write any Psychological Challenge you have faced"
            />
          </Form.Item>
          <Form.Item className="w-full mb-0" name="Description">
            <MyInput
              name="Description"
              icon={<PencilIcon />}
              placeholder="Description"
            />
          </Form.Item>
          <Form.Item
            className="w-full mb-0"
            name="Slide"
            label="Select the level of Psychological Challenges"
          >
            {/* <MySlide
              min={1}
              max={10}
              // value={typeof inputValue === "number" ? inputValue : 0}
            /> */}
            {/* <Slider min={1} max={10} /> */}
            <MySlide
              tooltip={{
                formatter: null,
              }}
              marks={marks}
              step={null}
            />
          </Form.Item>
          <Form.Item className="w-full mb-0" name="File">
            <MyFileUpload
              name="File"
              type="noGradient"
              action=""
              accept=".pdf, .doc, .docx, image/png, image/jpeg, image/jpg,"
              maxCount="1"
              placeholder="Upload Supporting Evidence"
            />
          </Form.Item>
          <div className="w-full flex justify-center gap-3">
            <GradientButton
              disabled={loading}
              type="submit"
              onClick={form.resetFields()}
            >
              <span>Save</span>
              {loading && <LoadingOutlined />}
            </GradientButton>
            <button
              disabled={loading}
              type="button"
              onClick={close}
              className="bg-gray-500 hover:bg-gray-600 text-pureWhite rounded-full py-2 px-4"
            >
              Cancel
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
  if (modal === "SocialChallenges") {
    return (
      <Modal isOpen={isOpen} key={key} close={loading ? () => {} : close}>
        <Form
          labelCol={1}
          onFinish={handleSave}
          layout="vertical"
          form={form}
          initialValues={isEdit ? { ...data } : {}}
          className="w-full mt-8 flex flex-wrap justify-between items-center gap-x-8 gap-y-5"
        >
          <Form.Item className="w-full mb-0" name="Name">
            <MyInput
              name="Name"
              icon={<PencilIcon />}
              placeholder="Write any Social Challenges you have faced"
            />
          </Form.Item>
          <Form.Item className="w-full mb-0" name="Description">
            <MyInput
              name="Description"
              icon={<PencilIcon />}
              placeholder="Description"
            />
          </Form.Item>
          <Form.Item
            className="w-full mb-0"
            name="Slide"
            label="Select the level of Social Challenges"
          >
            {/* <MySlide
              min={1}
              max={10}
              // value={typeof inputValue === "number" ? inputValue : 0}
            /> */}
            {/* <Slider min={1} max={10} /> */}
            <MySlide
              tooltip={{
                formatter: null,
              }}
              marks={marks}
              step={null}
            />
          </Form.Item>
          <Form.Item className="w-full mb-0" name="File">
            <MyFileUpload
              name="File"
              type="noGradient"
              action=""
              accept=".pdf, .doc, .docx, image/png, image/jpeg, image/jpg,"
              maxCount="1"
              placeholder="Upload Supporting Evidence"
            />
          </Form.Item>
          <div className="w-full flex justify-center gap-3">
            <GradientButton
              disabled={loading}
              type="submit"
              onClick={form.resetFields()}
            >
              <span>Save</span>
              {loading && <LoadingOutlined />}
            </GradientButton>
            <button
              disabled={loading}
              type="button"
              onClick={close}
              className="bg-gray-500 hover:bg-gray-600 text-pureWhite rounded-full py-2 px-4"
            >
              Cancel
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
};

function Modal({ children, close, isOpen }) {
  const handleOverlayClick = (e) => {
    // Only close the modal if the click target is the overlay (background)
    if (e.target === e.currentTarget) {
      close();
    }
  };

  return (
    <div
      onClick={handleOverlayClick}
      className={`fixed top-0 left-0 z-50 bg-gray-500/50 min-h-screen w-screen flex justify-center items-center transition-opacity duration-500 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div className="bg-pureWhite rounded-lg border-2 border-gray-100 shadow-md p-4 w-[500px]">
        {children}
      </div>
    </div>
  );
}

export default PersonalityAttributesModal;
